export const alphaNumericSpaceDash = new RegExp(/^[a-zA-Z0-9- ]+$/);
export default alphaNumericSpaceDash;
